import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/account/billing/')({
  beforeLoad: () => {
    throw redirect({
      to: '/administration/account/billing/$page/$limit',
      params: { page: '1', limit: '10' },
    });
  },
});
